"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Desio certificazione contatti
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorResponseDtoToJSON = exports.ErrorResponseDtoFromJSONTyped = exports.ErrorResponseDtoFromJSON = void 0;
const runtime_1 = require("../runtime");
const _1 = require("./");
function ErrorResponseDtoFromJSON(json) {
    return ErrorResponseDtoFromJSONTyped(json, false);
}
exports.ErrorResponseDtoFromJSON = ErrorResponseDtoFromJSON;
function ErrorResponseDtoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'message': !runtime_1.exists(json, 'message') ? undefined : json['message'],
        'statusCode': !runtime_1.exists(json, 'statusCode') ? undefined : json['statusCode'],
        'errorType': !runtime_1.exists(json, 'errorType') ? undefined : _1.ErrorEnumTypeFromJSON(json['errorType']),
    };
}
exports.ErrorResponseDtoFromJSONTyped = ErrorResponseDtoFromJSONTyped;
function ErrorResponseDtoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'message': value.message,
        'statusCode': value.statusCode,
        'errorType': _1.ErrorEnumTypeToJSON(value.errorType),
    };
}
exports.ErrorResponseDtoToJSON = ErrorResponseDtoToJSON;
